define([
	'jquery',
	'routes/helper',
	'components/consumerweb-client-error-logger/historyModel',
	'lib/pxpHelper',
	'routes/moneyflows/routesMapping',
	'routes/tables/wallet-table'
], function ($, SubRouteHelper, historyModel, pxpHelper, moneyflows, WalletRouteTable) {

	'use strict';

	var isFlow = $('body').data('isflow'),
		flowId = $('body').data('mnwFlowId') || null,
		withdrawUrl = $('body').data('withdrawRedirectUrl') || null;

	return SubRouteHelper.extend({

		/**
		 * Register all the interesting URIs that will fire off generic or specific functionality
		 */
		routes: WalletRouteTable.backbone,

		/**
		 * Main wallet route
		 */
		showWallet: function () {
			this.showView({
				name: 'wallet/index'
			});
			this.cleanView();
		},

		/**
		 *	Load wallet route
		 *	closes notification modal because we don't want a modal on top of another
		 *  @param action - wallet route's action
		 *	@param fn - callback function
		 */
		loadWalletRoute: function (action, fn) {
			this.showView({
				name: 'wallet/index',
				callback: function () {
					var $notificationModal = $('#notificationModal');

					if ($notificationModal) {
						$notificationModal.modal('hide');
					}

					fn();
				}
			});

			historyModel.addPath('wallet/' + action);
		},

		/**
		 *	Add callback
		 *	@param action - specific thing to add
		 */
		addCallback: function (action, returnUrl, fromForm) {
			var self = this,
				// Default value is read first so this should never be null
				useClassic = $('#wallet').data('bankspecs').useClassic;
			switch (action) {
				/* TODO: Remove creditcard once all of the summary endpoints are updated. */
				case 'creditcard':
					this.view.cardsView.addCard();
					break;
				case 'card':
					this.view.cardsView.addCard();
					break;
				case 'bank':
					if (useClassic) {
						window.location.href = '/cgi-bin/webscr?cmd=_profile-ach';
						return;
					}
					/**
					 * For add bank we need to make a PXP call to determine list of experiments that belong to this
					 * page and then load the overpanel, we pass in the pxp key that has details on the experiment
					 * such as page name and countries. This config is maintained in data/pxpCall.json
					 */
					pxpHelper.callRoute('ibanLocalBankDefault', function (experiments) {
						self.view.banksView.addBank({
							fromForm: fromForm,
							experiments: experiments,
							isFlow: isFlow,
							flowId: flowId
						});
					});
					break;
				case 'merchantGiftCards':
					this.view.merchantGCView.openSelectSponsorPage();
					break;
				case 'address':
					this.view.addAddress(returnUrl);
					break;
				default:
					break;
			}
		},

		/**
		 *	Add route
		 *	@param action - specific thing to add
		 */
		add: function (action, returnUrl, fromForm) {
			this.loadWalletRoute('add/' + action, this.addCallback.bind(this, action, returnUrl, fromForm));
		},

		/**
		 *	Show confirm email callback
		 */
		showConfirmEmail: function () {
			this.view.openConfirmEmail('home');
		},

		/**
		 *	Show confirmEmail route
		 */
		confirmEmail: function () {
			this.loadWalletRoute('confirmEmail', this.showConfirmEmail.bind(this));
		},

		/**
		 *	Show balance details callback
		 */
		showBalanceDetails: function () {
			this.view.openBalanceDetails();
		},

		/**
		 *	Show balance details route
		 */
		balance: function () {
			if (isFlow) {
				moneyflows.checkForRedirection(isFlow);
			} else {
				this.loadWalletRoute('balance', this.showBalanceDetails.bind(this));
			}
		},

		/**
		 * Show PAD details callback
		 */
		showPadDetails: function () {
			this.view.openPadDetails();
		},

		/**
		 * show PAD details route
		 */
		padDetails: function () {
			this.loadWalletRoute('pad', this.showPadDetails.bind(this));
		},

		proceedPadFlow: function() {
			this.view.onboardingPAD();
		},

		padFlow: function () {
			this.loadWalletRoute('pad', this.proceedPadFlow.bind(this));
		},

		/**
		 *	Card details callback
		 *	@param id - id of card to open
		 */
		showCard: function (id, action) {
			var cardSummaryView,
				cardDetailsView;

			// check if 3ds required before openCardDetails
			this.view.cardsView.check3dsAndOpenCardDetails(id, action);


			// edit card
			if (action === 'edit') {
				cardSummaryView = this.view.cardsView.cardDetailsView.cardSummaryView;
				if (cardSummaryView) {
					cardSummaryView.updateDetails();
				} else {
					this.view.cardsView.cardDetailsView.model.set('edit', true);
				}
			}

			/**
			 * This could have been added as js link but chose to add it to routes due to the following because
			 * we want to use backbone to keep track of URL's, there is an
			 * add address dropdown from which we either add a new address or cancel an existing address and in both cases we
			 * need to know which page we came from
			 */

			if (action === 'changeBrand') {
				cardDetailsView = this.view.cardsView.cardDetailsView;
				if (cardDetailsView) {
					cardDetailsView.displayUpdateCardBrand();
				}
			}
		},

		/**
		 *	Card details route
		 *	@param id - id of card to open
		 */
		card: function (id, action) {
			this.loadWalletRoute('card/' + id + '/' + (action || ''), this.showCard.bind(this, id, action));
		},

		/**
		 *	Bank details callback
		 *	@param id - id of bank to open
		 */
		showBank: function (id, fromUrl) {
			this.view.banksView.openBankDetails(id, fromUrl);
		},

		/**
		 *	Bank details route
		 *	@param id - id of bank to open
		 */
		bank: function (id, fromUrl) {
			this.loadWalletRoute('bank/' + id, this.showBank.bind(this, id, fromUrl));
		},

		/**
		 *	Saved offer details callback
		 *	@param {stirng} id - id of saved offer to open
		 */
		showSavedOffer: function (id) {
			this.view.savedOffersView.openSavedOfferDetails(id);
		},

		/**
		 *	Saved offer details route
		 *	@param {stirng} id - id of saved offer to open
		 */
		savedOffer: function (id) {
			this.loadWalletRoute('savedOffer/' + id, this.showSavedOffer.bind(this, id));
		},

		/**
		 *	Show credit product details callback
		 *	@param creditProduct - specific credit product to show
		 */
		showCreditProductDetails: function (creditProduct) {
			var creditView = this.view.creditProductView;
			for (var i = 0; i < creditView.length; i++) {
				// if user have multiple credit products, this will call appropriate credit product view
				if (creditView[i].model.get('creditProductType') === creditProduct) {
					creditView[i].showCreditProductDetails();
					break;
				}
			}
		},

		/**
		 *	Show credit product details route
		 *	@param creditProduct - specific credit product deatils which needs to be displayed
		 */
		creditProduct: function (creditProduct) {
			this.loadWalletRoute('creditProduct/' + creditProduct, this.showCreditProductDetails.bind(this, creditProduct));
		},

		/**
		 *	Show withdraw flow callback
		 */
		showWithdraw: function (section) {
			if (withdrawUrl) {
				window.location.href = withdrawUrl;
				return;
			}
			this.view.openBalanceAction('withdraw', section);
		},

		/**
		 *	Show withdraw flow route
		 */
		withdraw: function (section) {
			this.loadWalletRoute('withdraw/' + section, this.showWithdraw.bind(this, section));
		},

		/**
		 *	Show zero balance alert callback
		 */
		showZeroBalance: function () {
			if (withdrawUrl) {
				window.location.href = withdrawUrl;
				return;
			}
			this.view.openZeroBalanceAlert('wallet');
		},

		/**
		 *	Show zero balance alert route
		 */
		zeroBalance: function () {
			this.loadWalletRoute('zeroBalance', this.showZeroBalance.bind(this));
		},

		/**
		 *	Show add funds flow callback
		 */
		showAddFunds: function (section) {
			this.view.checkCIPStatus(section);
		},

		showRepayBalance: function() {
			this.view.skipCIP();
		},
		/**
		 *	Show add funds flow route
		 */
		addFunds: function (section) {
			this.loadWalletRoute('addFunds/' + section, this.showAddFunds.bind(this, section));
		},
		repayBalance: function () {
			this.loadWalletRoute('repayFunds', this.showRepayBalance.bind(this));
		},

		/**
		 *	Gift card details callback
		 *	@param id - id of gift card to open
		 */
		showGiftCard: function (id) {
			this.view.giftCardsView.openGiftCardDetails(id);
		},

		/**
		 *	Gift card details route
		 *	@param id - id of gift card to open
		 */
		giftCard: function (id) {
			this.loadWalletRoute('giftCard/' + id, this.showGiftCard.bind(this, id));
		},

		/**
		 * Merchant GC details callback
		 * @param id - id of the merchant gift card
		 */
		showMerchantGC: function (id, action) {
			var merchantgcView;

			if (action === 'edit') {
				this.view.merchantGCView.openMerchantGiftCardDetails(id);
				merchantgcView = this.view.merchantGCView.merchantGCDetailsView;
				if (merchantgcView) {
					merchantgcView.updateBalance();
				} else {
					this.view.merchantGCView.merchantGCDetailsView.model.set('edit', true);
				}
			} else if (action === 'add') {
				this.view.merchantGCView.openSelectSponsorPage(id);
				merchantgcView = this.view.merchantGCView.merchantgcSelectSponsorView;
				if (merchantgcView) {
					merchantgcView.selectSponsor(id);
				} else {
					this.view.merchantGCView.merchantGCDetailsView.model.set('add', true);
				}
			} else {
				this.view.merchantGCView.openMerchantGiftCardDetails(id);
			}
		},

		/**
		 * Merchant Gift Card Details Route
		 * @param id - id of merchant gift card
		 */
		merchantGC: function(id, action) {
			this.loadWalletRoute('merchantGC/' + id + '/' + (action || ''), this.showMerchantGC.bind(this, id, action));
		},

		/**
		 *	Confrm bank instantly  callback
		 *	@param id - id of bank to confirm
		 */
		showConfirmBankInstantly: function (id) {
			this.view.banksView.confirmBankInstantly(id);
		},

		/**
		 *	Confrm bank instantly route
		 *	@param id - id of bank to confirm
		 */
		confirmBankInstantly: function (id) {
			this.loadWalletRoute('confirmBankInstantly/' + id, this.showConfirmBankInstantly.bind(this, id));
		},

		showFABLogin: function (id) {
			this.loadWalletRoute('showFABLogin/' + id, this.fetchFABLogin.bind(this, id));
		},

		fetchFABLogin: function (id) {
			this.view.banksView.showFABLogin(id);
		},

		showFABSuccess: function() {
			this.loadWalletRoute('addConfirm/success/', this.fetchFABSuccess.bind(this));
		},

		fetchFABSuccess: function () {
			this.view.banksView.showFABSuccessPage();
		},

		addBankAfterAuthflow: function() {
			this.loadWalletRoute('addBank/saveBank', this.saveBankAfterAuthflow.bind(this));
		},

		saveBankAfterAuthflow: function() {
			this.view.banksView.addBankView.saveBankAfterAuthFlow();
		},
		/**
		 *	Display all unconfirm banks
		 */
		showUnconfirmedBanks: function() {
			this.loadWalletRoute('confirmbank', this.unconfirmBanks.bind(this));
		},

		unconfirmBanks: function() {
			this.view.banksView.showUnconfirmBanksPage();
		},

		showSettingsWalletPreferences: function() {
			this.loadWalletRoute('wallet', this.settingsWalletPreference.bind(this));
		},

		settingsWalletPreference: function() {
			this.view.showWalletPreferences();
		}
	});

});



//////////////////
// WEBPACK FOOTER
// ./routes/wallet.js
// module id = 861
// module chunks = 0